/**
 * 订单管理 充电订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>充电订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="订单时间:">
        <el-date-picker
        v-model="datetimerange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        format="yyyy-MM-dd"
        :picker-options="pickerOptionArrays"
      />
    </el-form-item>
      <el-form-item label="场地名称:">
        <el-select v-model="formInline.charging_stations_id" placeholder="请选择部门名称" clearable>
          <el-option v-for="item in station_names" :label="item.station_name" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备序列号">
        <el-input size="small" v-model="formInline.serial_number" placeholder="输入设备序列号"></el-input>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input size="small" v-model="formInline.swift_no" placeholder="输入订单号"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input size="small" v-model="formInline.tel" placeholder="输入手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="success" @click="exportData">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <!-- <el-table-column sortable prop="id" label="序号" >
      </el-table-column> -->
      <el-table-column sortable prop="swift_no" label="订单号" >
      </el-table-column>
      <el-table-column sortable prop="station_name" label="站点" >
      </el-table-column>
      <el-table-column sortable prop="serial_name" label="设备名称" >
      </el-table-column>
      <el-table-column sortable prop="serial_number" label="设备序列号" >
      </el-table-column>
      <el-table-column sortable prop="tel" label="手机号" >
      </el-table-column>
      <el-table-column sortable prop="create_time" label="创建时间" >
      </el-table-column>
      <el-table-column sortable prop="charge_start_time" label="充电开始时间" >
      </el-table-column>
      <el-table-column sortable prop="charge_end_time" label="充电结束时间" >
      </el-table-column>
      <el-table-column sortable prop="charge_time" label="充电时长（分钟）" >
      </el-table-column>
      <el-table-column sortable prop="total_energy" label="充电电量（度）" >
      </el-table-column>
      <el-table-column sortable prop="total_fee" label="充电金额（元）" >
        <template slot-scope="scope" >
          {{scope.row.total_fee/100 }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="fee" label="预付金额（元）" >
        <template slot-scope="scope" >
          {{scope.row.fee/100 }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="fee" label="退还金额（元）" >
        <template slot-scope="scope" v-if="scope.row.charge_status == 4">
          {{(scope.row.fee-scope.row.total_fee)/100 }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="stop_reason_desc" label="结束原因" >
      </el-table-column>


      <el-table-column sortable prop="charge_status" label="状态" >
        <!-- '0:未充电 1:充电中 2:充电结束 3.等待充电 4.关闭充电 5.等待关闭 6 待支付 7 已取消', -->
        <template slot-scope="scope">
          <el-button size="mini" v-if="scope.row.charge_status != 1 && scope.row.charge_status != 4" type="info"> {{ orderStatus[scope.row.charge_status] }}</el-button>
          <el-button size="mini" v-if="scope.row.charge_status == 4 " type="primary"> {{ orderStatus[scope.row.charge_status] }}</el-button>
          <el-button size="mini" v-if="scope.row.charge_status == 1" type="success"> {{ orderStatus[scope.row.charge_status] }}</el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button v-if="scope.row.charge_status == 1 " size="mini" type="primary" @click="closeChargeOrder(scope.$index, scope.row,2)">关闭订单</el-button>
          <el-button v-if="scope.row.charge_status == 1 || scope.row.charge_status == 5" size="mini" type="danger" @click="closeChargeOrder(scope.$index, scope.row,5)">强制结束</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
</div>
</template>

<script>
// 导入请求方法
import { getStationNames } from '../../api/station'
import { getChageOrders ,getChageOrdersUrl,closeChargeOrder} from '../../api/price'
import Pagination from '../../components/Pagination'
import moment from "moment";
export default {
  data() {
    return {
      pickerOptionArrays: {
          shortcuts: [{
            text: '当日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(moment().startOf('day'));
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(moment().startOf('isoWeek'));
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              start.setTime(moment().startOf('month'));
              picker.$emit('pick', [start, end]);
            }
          }]
        },

      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() >= Date.now() - 3600 * 1000 * 24 * 1;
        },
      },
      orderStatus : {
        0 :'未充电',
        1 :'充电中',
        2 :'充电结束',
        3 :'等待充电',
        4 :'已完成',
        5 :'等待关闭',
        6 :'待支付',
        7 :'已取消',
      },

      // 请求数据参数
      datetimerange:[moment().add(-7, "days"),moment().add(0, "days")],
      open_status_names:[{name:'非白名单',val:0},{name:'白名单',val:1}],
      formInline: {
        page: 1,
        limit: 10,
        tel: this.$route.query.tel?this.$route.query.tel:'',
        charging_stations_id:'',
        swift_no:'',
        serial_number:'',
        searchStartDate:'',
        searchEndDate:'',
        export:0,
        is_open_white:0,
        order_type:1
      },
      station_names:[],
      //用户数据
      listData: [],

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getStationNames()
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    closeChargeOrder(index, row,close_type) {
      this.$confirm('此操作将结束订单, 强制结束会导致直接退款，无法追回，是否继续?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          closeChargeOrder({swift_no:row.swift_no,close_type:close_type})
            .then(res => {
              if (res.code == 0 ) {
                this.$message({
                  type: 'success',
                  message: '已下发!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('关闭失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消关闭'
          })
        })
    },

    getStationNames(){
      getStationNames().then(res => {
        if (res.code == 0) {
            this.station_names = res.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },


    exportData(){
      this.loading = true
      if(this.datetimerange[0]&&this.datetimerange[1]){
        this.formInline.searchStartDate = moment(this.datetimerange[0]).format("YYYY-MM-DD")
        this.formInline.searchEndDate = moment(this.datetimerange[1]).format("YYYY-MM-DD")
      }else{
          this.formInline.searchStartDate = this.datetimerange[0]
          this.formInline.searchEndDate = this.datetimerange[1]
      }
      this.formInline.limit = 999
      this.formInline.export = 1
      this.formInline.token=localStorage.getItem('logintoken')


      var url = getChageOrdersUrl( this.formInline)
      console.log(url)
      window.open(url, "_blank");
      this.formInline.limit=10;
      this.formInline.export=0;
    },
    // 获取数据方法
        // 获取公司列表
    getdata() {
      this.loading = true
      if(this.datetimerange[0]&&this.datetimerange[1]){
        this.formInline.searchStartDate = moment(this.datetimerange[0]).format("YYYY-MM-DD")
        this.formInline.searchEndDate = moment(this.datetimerange[1]).format("YYYY-MM-DD")
      }else{
          this.formInline.searchStartDate = this.datetimerange[0]
          this.formInline.searchEndDate = this.datetimerange[1]
      }
      this.formInline.token=localStorage.getItem('logintoken')
      getChageOrders(this.formInline).then(res => {
        if (res.code == 0) {
          this.loading = false
          this.listData = res.data.data
          this.pageparm.currentPage = res.data.current_page
          this.pageparm.pageSize = res.data.per_page
          this.pageparm.total = res.data.total
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },





  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/order/WxCharge.vue